module.exports = __webpack_public_path__ + "static/media/link.b9ee0e3a.svg";